import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import moduleUser from '../store/userInfo';

const options = {
  confirmButtonColor: '#FB966E',
  confirmButtonText: '確定',
  cancelButtonText: '取消',
  customClass: {
    cancelButton: 'swal-cancel',
    confirmButton: 'swal-confirm',
  },
  willOpen() {
    document.querySelector('.swal-confirm').classList.add(moduleUser.state.userInfo.userStyle ? `swal-confirm-${moduleUser.state.userInfo.userStyle}` : 'swal-confirm');
    document.querySelector('.swal-cancel').classList.add(moduleUser.state.userInfo.userStyle ? `swal-cancel-${moduleUser.state.userInfo.userStyle}` : 'swal-cancel');
  },
};

Vue.use(VueSweetalert2, options);
